
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHydraulic08Off as ObiHydraulic08OffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-hydraulic-08-off.js';
 
 
 

 
 export const ObiHydraulic08Off = createComponent({
   react: React,
   tagName: 'obi-hydraulic-08-off',
   elementClass: ObiHydraulic08OffElement,
   events: {
     
   }
  });
 
 